<template>
  <div class="branches-card">
    <div class="branches-header">
      <div class="branches-header-icon">
        <feather-icon
          icon="GlobeIcon"
          size="22"
        />
      </div>
      <h3 class="branches-title">
        Our Branches
      </h3>
    </div>
    <div class="branches-list">
      <div
        v-for="(data, index) in branches"
        :key="index"
        :class="['branch-item', { 'branch-item-active': data.isActive }]"
        @click="changeBranch(data)"
      >
        <div class="branch-item-left">
          <div
            class="branch-flag"
            :style="{ '--img': `url(${data.img})` }"
          >
            <feather-icon
              icon="MapPinIcon"
              size="24"
              class="branch-flag-fallback"
            />
          </div>
          <div class="branch-info">
            <span class="branch-name">
              {{ data.name }}
            </span>
            <span class="branch-meta">
              <feather-icon
                icon="UsersIcon"
                size="14"
              />
              {{ data.employees }} employees
            </span>
          </div>
        </div>
        <div class="branch-item-right">
          <feather-icon
            :icon="data.isActive ? 'CheckCircleIcon' : 'ChevronRightIcon'"
            size="20"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import decryptData from '@/store/auth/decryptData'
import useChartData from './useChartData'

export default {
  props: {
    roleAdmin: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      office_id: 1,
      dataChartToTable: {},
      loadingChart: true,
      userData: [],
      loadingDataUser: false,
      /* eslint-disable */
      branches: [
        { id: 5, isActive: false, name: 'United Arab Emirates', img: require('@/assets/images/branchs/UnitedArabEmirates.png') },
        { id: 2, isActive: false, name: 'Jordan', img: require('@/assets/images/branchs/Jordan.png') },
        { id: 4, isActive: false, name: 'Kingdom of Saudi Arabia', img: require('@/assets/images/branchs/KingdomOfSaudiArabia.png') },
        { id: 1, isActive: true, name: 'Egypt', img: require('@/assets/images/branchs/Egypt.png') },
        { id: 3, isActive: false, name: 'Turkey', img: require('@/assets/images/branchs/Turkey.png') },
        { id: 6, isActive: false, name: 'Pakistan', img: require('@/assets/images/branchs/Pakistan.png') },
        { id: 7, isActive: false, name: 'India', img: require('@/assets/images/branchs/India.png') },
        { id: 8, isActive: false, name: 'China', img: require('@/assets/images/branchs/China.png') },
        { id: 10, isActive: false, name: 'Philippines', img: require('@/assets/images/branchs/Philippines.png') },
        { id: 13, isActive: false, name: 'Qatar', img: require('@/assets/images/branchs/Qatar.png') },
        { id: 9, isActive: false, name: 'Russia', img: require('@/assets/images/branchs/Russia.png') },
        { id: 14, isActive: false, name: 'Chennai, India', img: require('@/assets/images/branchs/India.png') },
      ],
    }
  },
  watch: {
    office_id() {
      this.getCharts()
      // reset cached user analysis so next bar click loads data for new office
      this.userData = []
      this.$emit('userData', this.userData)
    },
  },
  methods: {
    async initBranches() {
      await this.getEmployeesCount()
      this.$emit('loadingChart', this.loadingChart)
      this.getCharts()
    },
    changeBranch(selectedBranch) {
      this.branches.forEach(branch => {
        branch.isActive = branch.id === selectedBranch.id
      })
      this.office_id = selectedBranch.id
    },
    async getCharts() {
      this.loadingChart = true
      this.$emit('loadingChart', this.loadingChart)
      await useChartData(this.office_id, data => {
        this.dataChartToTable = data
        this.$emit('dataChartToTable', data)
      }, loading => {
        this.loadingChart = loading
        this.$emit('loadingChart', loading)
      })
    },
    async getUserData(userId) {
      if (!userId) return
      this.loadingDataUser = true
      this.$emit('loadingDataUser', this.loadingDataUser)

      await axios.get(`analysis?office_id=${this.office_id}&user_analysis_only=1&user_id=${userId}`)
        .then(res => {
          this.userData = decryptData(res.data.payload).data.analysis.users_analysis
          this.$emit('userData', this.userData)
        })
        .catch(error => {
          if (error) {
            this.loadingDataUser = false
            this.$emit('loadingDataUser', this.loadingDataUser)
          }
        })
        .finally(() => {
          this.loadingDataUser = false
          this.$emit('loadingDataUser', this.loadingDataUser)
        })
    },
    async getEmployeesCount() {
      const res = await axios.get('employees-count')
      const data = decryptData(res.data.payload).data
      console.log(data)
      const officeId = Number(localStorage.getItem('office_id'))

      if (this.roleAdmin === 'office-manager' || this.roleAdmin === 'hr-office') {
        this.branches = this.branches.filter(
          branch => Number(branch.id) === officeId,
        )
        if (this.branches.length > 0) {
          this.office_id = this.branches[0].id
          const count = data[this.branches[0].name]
          this.branches[0].employees = count || 0
        }
        return
      }

      this.branches = this.branches.map(branch => {
        const count = data[branch.name]
        return {
          ...branch,
          employees: count || 0,
        }
      })
    },
  },
  mounted() {
    this.initBranches()
  },
}
</script>

<style lang="scss" scoped>
.branches-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ebe9f1;
  box-shadow: 0 2px 8px rgba(34, 41, 47, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;

  @media (max-width: 991px) {
    min-height: 400px;
    max-height: 50vh;
  }
}

.branches-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.25rem;
  background: #f8f8f8;
  border-bottom: 1px solid #ebe9f1;
}

.branches-header-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: linear-gradient(135deg, #00cfe8 0%, #4dd8e8 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.branches-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #5e5873;
  margin: 0;
}

.branches-list {
  flex: 1;
  overflow-y: auto;
  padding: 0.75rem;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d8d6de;
    border-radius: 3px;
  }
}

.branch-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 0.5rem;

  &:hover {
    background: #f8f8f8;
  }

  &.branch-item-active {
    background: linear-gradient(135deg, rgba(115, 103, 240, 0.12) 0%, rgba(158, 149, 245, 0.08) 100%);
    border: 1px solid rgba(115, 103, 240, 0.25);

    .branch-name {
      color: #7367f0;
      font-weight: 700;
    }

    .branch-item-right {
      color: #28c76f;
    }
  }
}

.branch-item-left {
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 0;
}

.branch-flag {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background-image: var(--img);
    background-size: cover;
    background-position: center;
    border-radius: 10px;
  }
}

.branch-flag-fallback {
  position: relative;
  z-index: 0;
  color: #b9b9c3;
}

.branch-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.branch-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: #5e5873;
}

.branch-meta {
  font-size: 0.8rem;
  color: #b9b9c3;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.branch-item-right {
  color: #b9b9c3;
  flex-shrink: 0;
  transition: transform 0.2s;

  .branch-item:hover & {
    transform: translateX(2px);
    color: #7367f0;
  }
}
</style>
